
import { translateUi } from '@i18n/config';export function toCSV(
  headers: string[],
  rows: Array<Record<string, unknown>>,
): string {
  const escape = (val: unknown) => {
    if (val === null || val === undefined) return "";
    let s = String(val);
    if (s.includes('"')) s = s.replace(/"/g, '""');
    const needsQuotes = /[",\n\r]/.test(s);
    return needsQuotes ? `"${s}"` : s;
  };
  const lines = [headers.join(",")];
  for (const row of rows) {
    const line = headers.map((h) => escape((row as any)[h])).join(",");
    lines.push(line);
  }
  return lines.join("\n");
}

export function parseCSV(text: string): {
  headers: string[];
  rows: string[][];
} {
  const rows: string[][] = [];
  let i = 0;
  const len = text.length;
  let current: string[] = [];
  let field = "";
  let inQuotes = false;
  let afterClosingQuote = false;
  let fieldStarted = false;
  let lineNumber = 1;
  let quotedFieldLineNumber = 1;

  function endField() {
    current.push(field);
    field = "";
    fieldStarted = false;
    afterClosingQuote = false;
  }
  function endRow() {
    rows.push(current);
    current = [];
  }

  while (i < len) {
    const ch = text[i++];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
          afterClosingQuote = true;
        }
      } else {
        field += ch;
        if (ch === "\n") lineNumber += 1;
      }
      continue;
    }
    if (afterClosingQuote) {
      if (ch === ",") {
        endField();
        continue;
      }
      if (ch === "\n") {
        endField();
        endRow();
        lineNumber += 1;
        continue;
      }
      if (ch === "\r") {
        if (text[i] === "\n") i++;
        endField();
        endRow();
        lineNumber += 1;
        continue;
      }
      if (/\s/.test(ch)) continue;
      throw new Error(
        translateUi("malformedCsvOnRowValue0UnexpectedCharacter", "Malformed CSV on row {{value0}}: unexpected character after closing quote.", { value0: lineNumber }),
      );
    }
    if (ch === '"') {
      if (!fieldStarted || field.trim().length === 0) {
        field = "";
        inQuotes = true;
        fieldStarted = true;
        quotedFieldLineNumber = lineNumber;
        continue;
      }
      throw new Error(
        translateUi("malformedCsvOnRowValue0QuoteAppears", "Malformed CSV on row {{value0}}: quote appears inside an unquoted field.", { value0: lineNumber }),
      );
    }
    if (ch === ",") {
      endField();
      continue;
    }
    if (ch === "\n") {
      endField();
      endRow();
      lineNumber += 1;
      continue;
    }
    if (ch === "\r") {
      if (text[i] === "\n") i++;
      endField();
      endRow();
      lineNumber += 1;
      continue;
    }
    field += ch;
    fieldStarted = true;
  }

  if (inQuotes) {
    throw new Error(
      translateUi("malformedCsvOnRowValue0QuotedField", "Malformed CSV on row {{value0}}: quoted field is not closed.", { value0: quotedFieldLineNumber }),
    );
  }

  // flush
  if (
    afterClosingQuote ||
    fieldStarted ||
    field.length > 0 ||
    current.length > 0
  ) {
    endField();
    endRow();
  }

  const headers = rows.shift() || [];
  return { headers, rows };
}
